import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";

import CAStore from "../../Store/TemplateStore/template.store";
import { updatePlantInformation } from "../../network/cipAPI";

import CriticalDeleteDialog from "../../components/CriticalDeleteDialog";
import InputBox from "../../components/InputBox";
import DupontDatePicker from "../../components/DatePopover/DupontDatePicker";
import DupontRadio from "../../components/DupontRadio";
import { DatePickerConfig } from "../../components/DatePopover/DateTimeConfig";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";

import { PLANT_INFO, SELECTED_SECTION } from "./plantInformation.config";

export const store = CAStore;

const PlantInformation = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const plantInfo = PLANT_INFO(t);
  const selectedSection = SELECTED_SECTION(t);

  const plantName = useSelector((state) => state.plantName);
  const plantLocation = useSelector((state) => state.plantLocation);
  const water_type = useSelector((state) => state.water_type);
  const num_trains = useSelector((state) => state.num_trains);
  const tol_num_modules = useSelector((state) => state.tol_num_modules);
  const sel_train = useSelector((state) => state.sel_train);
  const sel_rack = useSelector((state) => state.sel_rack);
  const tol_active_area = useSelector((state) => state.tol_active_area);
  const sel_modules_per_rack = useSelector(
    (state) => state.sel_modules_per_rack
  );
  const sel_active_area = useSelector((state) => state.sel_active_area);
  const dataset_name = useSelector((state) => state.dataset_name);
  const sel_module_used = useSelector((state) => state.sel_module_used);
  const is_dupont_element = useSelector((state) => state.is_dupont_element);
  const sel_segment = useSelector((state) => state.sel_segment);
  const plantInfoValues = {
    plantName: plantName,
    plantLocation: plantLocation,
    water_type: water_type,
    num_trains: num_trains,
    tol_num_modules: tol_num_modules,
    sel_train: sel_train,
    sel_rack: sel_rack,
    tol_active_area: tol_active_area,
    sel_modules_per_rack: sel_modules_per_rack,
    sel_active_area: sel_active_area,
    dataset_name: dataset_name,
    sel_module_used: sel_module_used,
    is_dupont_element: is_dupont_element,
    sel_segment: sel_segment,
  };

  const replaceEmptyWithNull = (attribute) => {
    return attribute !== "" ? attribute : null;
  };

  const plantInformation = async () => {
    let additionErrors = false;

    if (
      (props.ra && installation_date === null) ||
      installation_date === "" ||
      installation_date === undefined
    ) {
      additionErrors = true;
      setInstallationDateError(
        t("plantInformationStrings.installationDateError")
      );
    }

    if (
      plantInfoValues.plantName &&
      plantInfoValues.plantLocation &&
      props.mandatoryThresholdFilled
    ) {
      if (props.ra && additionErrors) {
        return;
      } else {
        props.setActiveStep(1);
        let payload = {
          // setting: {
          //   flux: store.getState().flux,
          //   temperature: store.getState().temperature,
          //   permeate_quality: store.getState().permeate_quality,
          //   feed_quality: store.getState().feed_quality,
          //   pressure: store.getState().pressure,
          //   flow: store.getState().flow,
          //   volume: store.getState().volume,
          //   currency: store.getState().currency,
          //   conversion_rate: store.getState().conversion_rate,
          // },
        };
        if (props.ra) {
          payload = {
            ...payload,
            threshold: {
              max_feed_pressure: replaceEmptyWithNull(
                store.getState().max_feed_pressure
              ),
              max_permeate_quality: replaceEmptyWithNull(
                store.getState().max_permeate_quality
              ),
              std_warranty_period: replaceEmptyWithNull(
                store.getState().std_warranty_period
              ),
              startup_pressure_drop: replaceEmptyWithNull(
                store.getState().startup_pressure_drop
              ),
              designed_permeate_flow: replaceEmptyWithNull(
                store.getState().designed_permeate_flow
              ),
              std_membrane_age: replaceEmptyWithNull(
                store.getState().std_membrane_age
              ),
              max_pressure_drop: replaceEmptyWithNull(
                store.getState().max_pressure_drop
              ),
              min_permeate_flow: replaceEmptyWithNull(
                store.getState().min_permeate_flow
              ),
            },
            installation_date: installation_date
              ? moment(installation_date).format("YYYY-MM-DD")
              : "",
            warranty,
          };
        } else {
          payload = {
            ...payload,
            cost: {
              cip_alkali_price: replaceEmptyWithNull(
                store.getState().alkaliPrice
              ),
              cip_acid_price: replaceEmptyWithNull(store.getState().acidPrice),
              energy_price: replaceEmptyWithNull(store.getState().energyPrice),
              water_price: replaceEmptyWithNull(store.getState().waterPrice),
              downtime_cost: store.getState().costofDownTime,
              cip_solution: store.getState().additional_chemical_price,
              ceb_alkali_price: replaceEmptyWithNull(
                store.getState().cebAlkaliPrice
              ),
              ceb_acid_price: replaceEmptyWithNull(
                store.getState().cebAcidPrice
              ),
              ceb_solution: store.getState().ceb_additional_chemical_price,
            },
            default_cip: {
              design_bw_duration: store.getState().design_bw_duration,
              design_duration_btw_bw: store.getState().design_duration_btw_bw,

              acid_ceb_duration: store.getState().acid_ceb_duration,
              acid_ceb_soak_duration: store.getState().acid_ceb_soak_duration,
              acid_used_per_ceb: replaceEmptyWithNull(
                store.getState().acid_used_per_ceb
              ),
              acid_ceb_ph: store.getState().acid_ceb_ph,
              acid_ceb_temp: store.getState().acid_ceb_temp,
              alkali_ceb_duration: store.getState().alkali_ceb_duration,
              alkali_ceb_soak_duration:
                store.getState().alkali_ceb_soak_duration,
              alkali_used_per_ceb: replaceEmptyWithNull(
                store.getState().alkali_used_per_ceb
              ),
              alkali_ceb_ph: store.getState().alkali_ceb_ph,
              alkali_ceb_temp: store.getState().alkali_ceb_temp,

              acid_cip_duration: store.getState().acid_cip_duration,
              acid_cip_soak_duration: store.getState().acid_cip_soak_duration,
              acid_used_per_cip: replaceEmptyWithNull(
                store.getState().acid_used_per_cip
              ),
              acid_cip_ph: store.getState().acid_cip_ph,
              acid_cip_temp: store.getState().acid_cip_temp,
              alkali_cip_duration: store.getState().alkali_cip_duration,
              alkali_cip_soak_duration:
                store.getState().alkali_cip_soak_duration,
              alkali_used_per_cip: replaceEmptyWithNull(
                store.getState().alkali_used_per_cip
              ),
              alkali_cip_ph: store.getState().alkali_cip_ph,
              alkali_cip_temp: store.getState().alkali_cip_temp,
            },
          };
        }
        dispatch({
          type: "STORE_PLANT_DETAILS",
          payload: {
            installation_date: moment(installation_date).format("YYYY-MM-DD"),
            warranty: warranty,
          },
        });

        const response = await updatePlantInformation(payload);
        setInstallationDateError(null);
      }
    }
  };

  React.useImperativeHandle(ref, () => ({ plantInformation }));
  const [installation_date, setInstallationDate] = useState(
    useSelector((state) =>
      state.installation_date && state.installation_date !== "None"
        ? new Date(state.installation_date)
        : ""
    )
  );
  const [installationDateError, setInstallationDateError] = useState("");
  const [warranty, setWarranty] = useState(
    useSelector((state) => state.warranty.toString())
  );
  const [warrantyPopup, setWarrantyPopup] = useState(false);

  const onDateChange = (value) => {
    setInstallationDateError("");
    setInstallationDate(value);
  };
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setWarranty(value);
    if (value === "true") setWarrantyPopup(true);
  };
  const onCloseClicked = (event) => {
    setWarrantyPopup(false);
  };

  return (
    <div
      className="lightGrayBorder"
      style={{ padding: "16px", marginTop: "16px" }}
    >
      <div className="headerTealText" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{t("plantInformationStrings.plantInfo")}</span>
        <PopoverText
          descriptor={<img src={InfoIconGreen} alt="icon" />}
          descriptionText={t("plantInformationStrings.plantSectionReview")}
        />
      </div>
      <div className="plant-grid-container">
        {Object.keys(plantInfo).map((info) => (
          <div className="plant-grid-item">
            <InputBox
              value={plantInfoValues[info]}
              placeholder={plantInfo[info].labelText}
              labelText={plantInfo[info].labelText}
              disabled
              hideClearBtn
            />
          </div>
        ))}

        {props.ra && (
          <>
            <div className="grid-item">
              <DupontDatePicker
                dateFormat={t("ValueStrings.DATE_FORMAT_SMALL")}
                selected={installation_date ? installation_date : ""}
                onChange={onDateChange}
                startDate={new Date()}
                label={t("plantInformationStrings.installation_date")}
                //minDate={cipStartDate}
                maxDate={new Date()}
                labelClass="dupont-form-label wrapText text-left"
                className={"width-fill"}
                isRequired
                error={installationDateError}
                {...DatePickerConfig}
              />
            </div>
            <div className="grid-item">
              <div className="checkbox-label-width ">
                {t("plantInformationStrings.warranty")}
              </div>
              <div
                key="warrantyGroup"
                onChange={handleOptionChange}
                className="checkbox-container"
              >
                <DupontRadio
                  text={t("ValueStrings.yes")}
                  checked={warranty === "true"}
                  value={"true"}
                  name="warrantyGroup"
                />
                <DupontRadio
                  text={t("ValueStrings.no")}
                  checked={warranty === "false"}
                  value={"false"}
                  name="warrantyGroup"
                />
              </div>
            </div>
            {warrantyPopup && (
              <CriticalDeleteDialog
                type="warning"
                title={t("plantInformationStrings.warrantyNotice")}
                description={t("plantInformationStrings.warrantyWarning")}
                onDialogClose={onCloseClicked}
                cancelBtnText={t("ValueStrings.close")}
              />
            )}
          </>
        )}
      </div>
      <div className="margin-top-20 font-bold ">
        {t("plantInformationStrings.selectedSection")}
        <div className="selected-grid-container ">
          {Object.keys(selectedSection).map((info) => (
            <div className="plant-grid-item">
              <InputBox
                value={plantInfoValues[info]}
                placeholder={selectedSection[info].labelText}
                labelText={selectedSection[info].labelText}
                hideClearBtn
                disabled
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default PlantInformation;
